import { render, staticRenderFns } from "./OrderStatusFilter.vue?vue&type=template&id=09aad328&scoped=true&"
import script from "./OrderStatusFilter.vue?vue&type=script&lang=js&"
export * from "./OrderStatusFilter.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusFilter.vue?vue&type=style&index=0&id=09aad328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aad328",
  null
  
)

/* custom blocks */
import block0 from "./OrderStatusFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports